<template>
  <b-card no-body class="mt-2 overflow-hidden">
    <b-row class="mb-3">
      <b-col cols="12">
        <b-row>
          <!-- Avatar -->
          <b-col cols="12" sm="3">
            <b-row>
              <b-col cols="12" class="avatar mt-4 mb-4">
                <b-avatar v-if="image" :src="src" size="20rem" />
                <b-avatar
                  v-else
                  :src="require('@/assets/images/login/avatar.svg')"
                  size="20rem"
                />
              </b-col>
              <b-col cols="12" class="avatar-information">
                <b-col class="charge">
                  <img
                    :src="
                      require('@/assets/images/icons/checkbox-circle-line.svg')
                    "
                    alt="worker"
                  />
                  <h4>Trabajador Activo</h4>
                </b-col>
                <b-col class="d-flex justify-content-center p-0">
                  <div>Desde 11/02/2018</div>
                </b-col>
              </b-col>
            </b-row>
          </b-col>

          <!-- information -->
          <b-col cols="12" sm="9">
            <b-card-body>
              <b-card-text>
                <b-form action="#">
                  <b-row>
                    <b-col cols="12" sm="6">
                      <b-form-group cols="6" class="information-input">
                        <label>Nombre completo</label>
                        <b-form-input
                          type="text"
                          placeholder="Nombre completo"
                          class="form-control"
                          :value="employee?.name"
                          disabled
                          readonly
                        />
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6">
                      <b-form-group cols="6" class="information-input">
                        <label>Sexo</label>
                        <b-form-input
                          type="text"
                          placeholder="Sexo"
                          class="form-control"
                          :value="employee?.gender"
                          disabled
                          readonly
                        />
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6">
                      <b-form-group cols="6" class="information-input">
                        <label>ID</label>
                        <b-form-input
                          type="text"
                          placeholder="ID"
                          class="form-control"
                          disabled
                          :value="employee?.cc"
                          readonly
                        />
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6">
                      <b-form-group cols="6" class="information-input">
                        <label>Edad</label>
                        <b-form-input
                          type="text"
                          placeholder="Edad"
                          class="form-control"
                          :value="employee?.age"
                          disabled
                          readonly
                        />
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6">
                      <b-form-group cols="6" class="information-input">
                        <label>Área</label>
                        <b-form-input
                          type="text"
                          placeholder="Área"
                          class="form-control"
                          :value="employee?.core_area?.name"
                          disabled
                          readonly
                        />
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6">
                      <b-form-group cols="6" class="information-input">
                        <label>Teléfono</label>
                        <b-form-input
                          type="text"
                          placeholder="Teléfono"
                          class="form-control"
                          :value="employee?.phone"
                          disabled
                          readonly
                        />
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6">
                      <b-form-group cols="6" class="information-input">
                        <label>Cargo</label>
                        <b-form-input
                          type="text"
                          placeholder="Cargo"
                          class="form-control"
                          :value="employee?.position?.name"
                          disabled
                          readonly
                        />
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6">
                      <b-form-group cols="6" class="information-input">
                        <label>Sindicato</label>
                        <b-form-input
                          type="text"
                          placeholder="Sindicato"
                          class="form-control"
                          :value="employee?.labor_union"
                          disabled
                          readonly
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-text>
            </b-card-body>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: "InformationEmployee",
  props: {
    employee: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      image: true,
    };
  },
  computed: {
    src() {
      return require("@/assets/images/login/avatar.svg");
    },
  },
};
</script>

<style lang="scss">
.avatar {
  height: 70%;
  align-items: center;
  text-align: center;
  padding: 0;
  font: normal normal 400 16px/28px "Ubuntu";
  color: #263238;
}

.avatar-information {
  width: 82%;
  img {
    width: 20px;
    height: 20px;
    background: rgba(255, 255, 255, 0);

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
  }
  h4 {
    color: #00761a;
    margin: 0;
  }
  a {
    cursor: auto;
    color: black;
    font-weight: 400;
    font-size: 15px;
    line-height: 28px;
  }
}

.charge {
  background: #f6ffed;
  border-radius: 100px;
  display: flex;
  align-items: center;
  padding: 4px 6px;
  width: max-content;
  margin: 0 auto;
  gap: 8px;
}

.information-input {
  position: relative;
  margin-top: 8px;
  margin-bottom: 8px;
  border: 1px solid #b0bec5;
  box-sizing: border-box;
  border-radius: 8px;
  label {
    position: absolute;
    left: 6px;
    top: -10px;
    line-height: 1;
    font-weight: bold;
    padding: 4px 6px;
    background: white;

    font-family: Ubuntu, serif;
    font-style: normal;
    font-size: 14px;
    align-items: center;
    color: #b0bec5;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0 4px;
  }
  input {
    position: static;
    width: 99%;
    height: 28px;
    left: calc(50% - 412px / 2);
    top: calc(50% - 28px / 2);
    background: #ffffff00 !important;
    font: normal normal 300 16px/20px "Ubuntu";
    color: #000000;
    margin: 8px;
    border: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    &:focus,
    &:active {
      outline: 0;
      border: 0;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      box-shadow: none;
    }
  }
}
</style>
